import React from 'react'
import { BsTwitter, BsTrophyFill } from "react-icons/bs";
import { FaCheckCircle } from "react-icons/fa";
import MarginBottom from '../MarginBottom';


const BottomMainMarketing = () => {
  return (
    <>
      {/* <h2 className="text-3xl sm:text-4xl my-10 text-lyellow px-[2.3em] font-semibold text-center sm:text-left">Steps</h2> */}
      <div className="flex flex-col justify-center items-center md:grid md:grid-cols-2 lg:grid-cols-3 px-[5em] ">
        <div className="block p-6 max-w-sm bg-black/40 rounded-2xl border border-black/80 shadow-md cursor-pointer">
          <div className="w-full flex justify-center items-center">
            <BsTwitter className="inline-block h-12 w-12 text-lyellow mb-4" />
          </div>
          <h5 className="mb-2 text-lg font-bold tracking-tight text-lyellow">
            1. Share On Twitter
          </h5>
          <p className="font-normal text-white">
            Weekly link and hashtag will be posted which can be shared on twitter.
          </p>
        </div>

        <div className="block p-6   max-w-sm bg-black/40 rounded-2xl border border-black/80 shadow-md cursor-pointer">
          <div className="w-full flex justify-center items-center">
            <FaCheckCircle className="inline-block h-12 w-12 text-lyellow mb-4" />
          </div>
          <h5 className="mb-2 text-lg font-bold tracking-tight text-lyellow">
            2. Submit Details
          </h5>
          <p className="font-normal text-white">
            Share your twitter username and wallet address only once.
          </p>
        </div>

        <div className="block p-6 max-w-sm bg-black/40 rounded-2xl border border-black/80 shadow-md cursor-pointer">
          <div className="w-full flex justify-center items-center">
            <BsTrophyFill className="inline-block h-12 w-12 text-lyellow mb-4" />
          </div>
          <h5 className="mb-2 text-lg font-bold tracking-tight text-lyellow">
            3. Win Reward
          </h5>
          <p className="font-normal text-white">
            The winner is selected randomly but the more you share the more your chances gets.
          </p>
        </div>
      </div>
    </>
  )
}

export default BottomMainMarketing